import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position on navigation.
 *
 * This used to only fire for an explicit list of routes, so most page
 * changes kept the previous scroll offset; individual components then
 * worked around it with their own `window.scrollTo` calls tied to data
 * arriving, which fought with the user's scrolling. One place now owns it.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
